module.exports = __webpack_public_path__ + "img/chemistry.e52b7fe.jpg";